<template>
  <div class="home-page">
    <!-- Navbar Area -->
    <div class="navbar-area" :class="{ 'is-sticky': isSticky }">
      <div class="template-responsive-navbar">
          <div class="container">
              <div class="template-responsive-menubar">
                  <div class="logo">
                      <router-link to="/">
                        <img :src="require('../assets/images/homelogo.png')" alt="ProxyLink logo" style="height: 55px; width: auto;">
                      </router-link>
                  </div>
                  <div class="meanmenu-reveal" id="meanmenu-reveal" @click="toggleMobileMenu"><span></span></div>
              </div>
          </div>
          <!-- Mobile Menu -->
          <div class="mean-nav" :class="{ 'mean-show': isMobileMenuOpen }">
              <div class="mobile-menu-container">
                  <ul class="navbar-nav">
                    <li class="nav-item"><router-link to="/" class="nav-link active" @click.native="handleMobileNavClick('/')">{{ t.home }}</router-link></li>
                    
                    <li class="nav-item"><a href="#" class="dropdown-toggle nav-link" @click="toggleDropdown($event, 'services')">{{ t.services }} <i class="bx bx-plus dropdown-icon"></i></a>
                      <ul class="dropdown-menu" :class="{ 'show': activeDropdown === 'services' }">
                        <li class="nav-item"><router-link to="/dynamic" class="nav-link" @click.native="handleMobileNavClick('/dynamic')">{{ t.serviceDynamic }}</router-link></li>
                        <li class="nav-item"><router-link to="/static" class="nav-link" @click.native="handleMobileNavClick('/static')">{{ t.serviceStatic }}</router-link></li>
                      </ul>
                    </li>
                    
                    <li class="nav-item"><a href="#" class="dropdown-toggle nav-link" @click="toggleDropdown($event, 'blog')">{{ t.blog }} <i class="bx bx-plus dropdown-icon"></i></a>
                      <ul class="dropdown-menu" :class="{ 'show': activeDropdown === 'blog' }">
                        <li class="nav-item"><router-link to="/faq" class="nav-link" @click.native="handleMobileNavClick('/faq')">{{ t.faq }}</router-link></li>
                      </ul>
                    </li>
                    
                    <!-- Language Switcher -->
                    <li class="nav-item">
                      <a href="#" class="dropdown-toggle nav-link" @click="toggleDropdown($event, 'language')">
                        {{ languageState.currentLanguage === 'en' ? 'English' : '简体中文' }} <i class="bx bx-plus dropdown-icon"></i>
                      </a>
                      <ul class="dropdown-menu" :class="{ 'show': activeDropdown === 'language' }">
                        <li class="nav-item">
                          <button class="nav-link language-option" @click="setLanguage('en')" style="padding: 10px 0 10px 20px;">English</button>
                        </li>
                        <li class="nav-item">
                          <button class="nav-link language-option" @click="setLanguage('zh')" style="padding: 10px 0 10px 20px;">简体中文</button>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  
                  <div class="others-option d-flex flex-column mt-4">
                    <div class="item mb-3">
                      <a href="/login" class="default-btn">{{ t.signIn }}</a>
                    </div>
                    
                    <div class="item">
                      <a href="/register" class="default-btn">{{ t.signUp }}</a>
                    </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="template-navbar">
        <div class="container">
          <nav class="navbar navbar-expand-md navbar-light">
            <a class="navbar-brand" href="javascript:;">
              <img :src="require('../assets/images/homelogo.png')" alt="ProxyLink logo" style="height: 55px; width: auto;">
            </a>

            <button class="navbar-toggler" type="button" @click="isNavCollapsed = !isNavCollapsed" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse mean-menu" :class="{ 'show': !isNavCollapsed }">
              <ul class="navbar-nav">
                <li class="nav-item"><router-link to="/" class="nav-link active">{{ t.home }}</router-link></li>

                <li class="nav-item"><a href="#" class="dropdown-toggle nav-link">{{ t.services }}</a>
                  <ul class="dropdown-menu">
                    <li class="nav-item"><router-link to="/dynamic" class="nav-link">{{ t.serviceDynamic }}</router-link></li>
                    
                    <li class="nav-item"><router-link to="/static" class="nav-link">{{ t.serviceStatic }}</router-link></li>
                  </ul>
                </li>

                <li class="nav-item"><a href="#" class="dropdown-toggle nav-link">{{ t.blog }}</a>
                  <ul class="dropdown-menu">
                    <li class="nav-item"><router-link to="/faq" class="nav-link">{{ t.faq }}</router-link></li>
                  </ul>
                </li>
                
                <!-- <li class="nav-item"><a href="contact.html" class="nav-link">{{ t.contact }}</a></li> -->
                
                <!-- Language Switcher -->
                <li class="nav-item">
                  <a href="#" class="dropdown-toggle nav-link">
                    {{ languageState.currentLanguage === 'en' ? 'English' : '简体中文' }}
                  </a>
                  <ul class="dropdown-menu">
                    <li class="nav-item"><button class="nav-link language-option" @click="setLanguage('en')">English</button></li>
                    <li class="nav-item"><button class="nav-link language-option" @click="setLanguage('zh')">简体中文</button></li>
                  </ul>
                </li>
              </ul>

              <div class="others-option d-flex align-items-center">
                <div class="item">
                  <a href="/login" class="default-btn">{{ t.signIn }}</a>
                </div>
                
                <div class="item">
                  <a href="/register" class="default-btn">{{ t.signUp }}</a>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
    <!-- End Navbar Area -->

    <!-- Banner Wrapper -->
    <div class="banner-wrapper">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="banner-content">
              <h1>{{ t.bannerTitle }}</h1>
              <p>{{ t.bannerSubtitle }}</p>
              <a href="/login" class="default-btn">{{ t.learnMore }}</a>
            </div>
          </div>

          <div class="col-lg-6 col-md-12">
            <div class="banner-image">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <div class="image">
                    <img :src="require('../assets/images/banner1.jpg')" alt="image">
                  </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6">
                  <div class="image">
                    <img :src="require('../assets/images/banner2.jpg')" alt="image">
                  </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6">
                  <div class="image">
                    <img :src="require('../assets/images/banner3.jpg')" alt="image">
                  </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6">
                  <div class="image">
                    <img :src="require('../assets/images/banner4.jpg')" alt="image">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="background-shape">
        <div class="circle1"></div>
        <div class="circle2"></div>
        <div class="circle3"></div>
        <div class="circle4"></div>
      </div>
    </div>
    <!-- End Banner Wrapper -->

    <!-- Featured Services Section -->
    <section class="featured-services-section bg-F7FAFD pb-70">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="featured-services-box">
              <i class='bx bx-bookmark-alt-plus'></i>
              <h3><a href="services-details.html">{{ t.contentManage }}</a></h3>
              <p>{{ t.serviceDesc }}</p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="featured-services-box">
              <i class='bx bx-pen'></i>
              <h3><a href="services-details.html">{{ t.oneClick }}</a></h3>
              <p>{{ t.serviceDesconeClick }}</p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="featured-services-box">
              <i class='bx bx-network-chart'></i>
              <h3><a href="services-details.html">{{ t.optimizationPlace }}</a></h3>
              <p>{{ t.serviceDescoptimizationPlace }}</p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="featured-services-box">
              <i class='bx bx-category'></i>
              <h3><a href="services-details.html">{{ t.scaleFast }}</a></h3>
              <p>{{ t.serviceDescscaleFast }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Featured Services Section -->

    <!-- Features Section -->
    <section class="features-section ptb-100">
      <div class="container">
        <div class="features-box row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="features-image">
              <img :src="require('../assets/images/features1.png')" alt="image">
            </div>
          </div>

          <div class="col-lg-6 col-md-12">
            <div class="features-content">
              <h2>{{ t.hungrySuccess }}</h2>
              <p>{{ t.featuresDesc }}</p>
              <ul class="list">
                <li><i class='bx bxs-arrow-to-right'></i><a href="services-details.html">{{ t.residentialIP }}</a></li>
                <li><i class='bx bxs-arrow-to-right'></i><a href="services-details.html">{{ t.globalIPCoverage }}</a></li>
                <li><i class='bx bxs-arrow-to-right'></i><a href="services-details.html">{{ t.highSpeed }}</a></li>
                <li><i class='bx bxs-arrow-to-right'></i><a href="services-details.html">{{ t.unlimitedBandwidth }}</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div class="features-box row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="features-content">
              <h2>{{ t.softwareDev }}</h2>
              <p>{{ t.globalCoverageDesc }}</p>
              <ul class="list">
                <li><i class='bx bxs-arrow-to-right'></i><a href="services-details.html">{{ t.countries }}</a></li>
                <li><i class='bx bxs-arrow-to-right'></i><a href="services-details.html">{{ t.millionsOfIPs }}</a></li>
                <li><i class='bx bxs-arrow-to-right'></i><a href="services-details.html">{{ t.autoRotation }}</a></li>
                <li><i class='bx bxs-arrow-to-right'></i><a href="services-details.html">{{ t.uptime }}</a></li>
              </ul>
            </div>
          </div>

          <div class="col-lg-6 col-md-12">
            <div class="features-image">
              <img :src="require('../assets/images/features2.png')" alt="image">
            </div>
          </div>
        </div>

        <div class="features-box row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="features-image">
              <img :src="require('../assets/images/features3.png')" alt="image">
            </div>
          </div>

          <div class="col-lg-6 col-md-12">
            <div class="features-content">
              <h2>{{ t.customSoftware }}</h2>
              <p>{{ t.highPerformanceDesc }}</p>
              <ul class="list">
                <li><i class='bx bxs-arrow-to-right'></i><a href="services-details.html">{{ t.supportProtocols }}</a></li>
                <li><i class='bx bxs-arrow-to-right'></i><a href="services-details.html">{{ t.apiSupport }}</a></li>
                <li><i class='bx bxs-arrow-to-right'></i><a href="services-details.html">{{ t.technicalSupport }}</a></li>
                <li><i class='bx bxs-arrow-to-right'></i><a href="services-details.html">{{ t.flexiblePricing }}</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Features Section -->

    <!-- Portfolio Section -->
    <section class="portfolio-sction pt-100 pb-70">
      <div class="container">
        <div class="section-title">
          <h2>{{ t.portfolioTitle }}</h2>
          <p>{{ t.portfolioSubtitle }}</p>
        </div>

        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-6">
            <div class="portfolio-box">
              <div class="content">
                <h3>{{ t.portfolioItem1 }}</h3>
                <div class="category">
                  <span>{{ t.portfolioDesc1 }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 col-sm-6">
            <div class="portfolio-box">
              <div class="content">
                <h3>{{ t.portfolioItem2 }}</h3>
                <div class="category">
                  <span>{{ t.portfolioDesc2 }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 col-sm-6">
            <div class="portfolio-box">
              <div class="content">
                <h3>{{ t.portfolioItem3 }}</h3>
                <div class="category">
                  <span>{{ t.portfolioDesc3 }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 col-sm-6">
            <div class="portfolio-box">
              <div class="content">
                <h3>{{ t.portfolioItem4 }}</h3>
                <div class="category">
                  <span>{{ t.portfolioDesc4 }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 col-sm-6">
            <div class="portfolio-box">
              <div class="content">
                <h3>{{ t.portfolioItem5 }}</h3>
                <div class="category">
                  <span>{{ t.portfolioDesc5 }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 col-sm-6">
            <div class="portfolio-box">
              <div class="content">
                <h3>{{ t.portfolioItem6 }}</h3>
                <div class="category">
                  <span>{{ t.portfolioDesc6 }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Portfolio Section -->

        <!-- Partner Section -->
    <div class="partner-section bg-fbfbfb">
        <div class="container">
            <div class="partner-title">
                <h3>{{ t.partnerTitle }}</h3>
            </div>

            <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-6 col-6">
                    <div class="partner-item">
                        <div class="country-card">
                            <img src="https://flagcdn.com/48x36/us.png" alt="United States" class="country-flag" width="48" height="36">
                            <div class="country-info">
                                <h4>United States</h4>
                                <span class="country-number">1341385</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6 col-6">
                    <div class="partner-item">
                        <div class="country-card">
                            <img src="https://flagcdn.com/48x36/de.png" alt="Germany" class="country-flag" width="48" height="36">
                            <div class="country-info">
                                <h4>Germany</h4>
                                <span class="country-number">1103502</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6 col-6">
                    <div class="partner-item">
                        <div class="country-card">
                            <img src="https://flagcdn.com/48x36/gb.png" alt="United Kingdom" class="country-flag" width="48" height="36">
                            <div class="country-info">
                                <h4>United Kingdom</h4>
                                <span class="country-number">199240</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6 col-6">
                    <div class="partner-item">
                        <div class="country-card">
                            <img src="https://flagcdn.com/48x36/fr.png" alt="France" class="country-flag" width="48" height="36">
                            <div class="country-info">
                                <h4>France</h4>
                                <span class="country-number">198502</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6 col-6">
                    <div class="partner-item">
                        <div class="country-card">
                            <img src="https://flagcdn.com/48x36/ca.png" alt="Canada" class="country-flag" width="48" height="36">
                            <div class="country-info">
                                <h4>Canada</h4>
                                <span class="country-number">187952</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6 col-6">
                    <div class="partner-item">
                        <div class="country-card">
                            <img src="https://flagcdn.com/48x36/br.png" alt="Brazil" class="country-flag" width="48" height="36">
                            <div class="country-info">
                                <h4>Brazil</h4>
                                <span class="country-number">1213841</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6 col-6">
                    <div class="partner-item">
                        <div class="country-card">
                            <img src="https://flagcdn.com/48x36/es.png" alt="Spain" class="country-flag" width="48" height="36">
                            <div class="country-info">
                                <h4>Spain</h4>
                                <span class="country-number">1183945</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6 col-6">
                    <div class="partner-item">
                        <div class="country-card">
                            <img src="https://flagcdn.com/48x36/it.png" alt="Italy" class="country-flag" width="48" height="36">
                            <div class="country-info">
                                <h4>Italy</h4>
                                <span class="country-number">192507</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6 col-6">
                    <div class="partner-item">
                        <div class="country-card">
                            <img src="https://flagcdn.com/48x36/vn.png" alt="Vietnam" class="country-flag" width="48" height="36">
                            <div class="country-info">
                                <h4>Vietnam</h4>
                                <span class="country-number">1108403</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6 col-6">
                    <div class="partner-item">
                        <div class="country-card">
                            <img src="https://flagcdn.com/48x36/ph.png" alt="Philippines" class="country-flag" width="48" height="36">
                            <div class="country-info">
                                <h4>Philippines</h4>
                                <span class="country-number">1128407</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6 col-6">
                    <div class="partner-item">
                        <div class="country-card">
                            <img src="https://flagcdn.com/48x36/pl.png" alt="Poland" class="country-flag" width="48" height="36">
                            <div class="country-info">
                                <h4>Poland</h4>
                                <span class="country-number">188205</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6 col-6">
                    <div class="partner-item">
                        <div class="country-card">
                            <img src="https://flagcdn.com/48x36/jp.png" alt="Japan" class="country-flag" width="48" height="36">
                            <div class="country-info">
                                <h4>Japan</h4>
                                <span class="country-number">1114604</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Partner Section -->

    <!-- Pricing Section -->
    <section class="pricing-section pb-70">
      <div class="container">
        <div class="section-title">
          <h2>{{ t.pricingTitle }}</h2>
          <p>{{ t.pricingSubtitle }}</p>
        </div>

        <div class="row justify-content-center">
          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="pricing-plan">
              <div class="title">
                <div class="icon">
                  <i class='bx bx-data'></i>
                </div>
                <h3>BEGINNER</h3>
                <span>1GB</span>
              </div>
              <ul class="features">
                <li><i class='bx bxs-badge-check'></i>{{ t.premiumIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.rotatingSticky }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.highTrustIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.unlimitedThreads }}</li>
              </ul>
              <div class="pricing-footer">
                <div class="price">
                  $6
                  <span>/month</span>
                </div>
                <a href="/login" class="default-btn">{{ t.getNow }}</a>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="pricing-plan">
              <div class="title">
                <div class="icon">
                  <i class='bx bx-data'></i>
                </div>
                <h3>BEGINNER</h3>
                <span>10GB</span>
              </div>
              <ul class="features">
                <li><i class='bx bxs-badge-check'></i>{{ t.premiumIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.rotatingSticky }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.highTrustIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.unlimitedThreads }}</li>
              </ul>
              <div class="pricing-footer">
                <div class="price">
                  $60
                  <span>/month</span>
                </div>
                <a href="/login" class="default-btn">{{ t.getNow }}</a>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="pricing-plan">
              <div class="title">
                <div class="icon">
                  <i class='bx bx-data'></i>
                </div>
                <h3>BEGINNER</h3>
                <span>50GB</span>
              </div>
              <ul class="features">
                <li><i class='bx bxs-badge-check'></i>{{ t.premiumIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.rotatingSticky }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.highTrustIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.unlimitedThreads }}</li>
              </ul>
              <div class="pricing-footer">
                <div class="price">
                  $300
                  <span>/month</span>
                </div>
                <a href="/login" class="default-btn">{{ t.getNow }}</a>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="pricing-plan">
              <div class="title">
                <div class="icon">
                  <i class='bx bx-data'></i>
                </div>
                <h3>BEGINNER</h3>
                <span>100GB</span>
              </div>
              <ul class="features">
                <li><i class='bx bxs-badge-check'></i>{{ t.premiumIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.rotatingSticky }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.highTrustIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.unlimitedThreads }}</li>
              </ul>
              <div class="pricing-footer">
                <div class="price">
                  $600
                  <span>/month</span>
                </div>
                <a href="/login" class="default-btn">{{ t.getNow }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Pricing Section -->

    <!-- Blog Section -->
    <!-- <section class="blog-section pt-100 pb-70">
        <div class="container">
            <div class="section-title">
                <h2>{{ t.blogTitle }}</h2>
                <p>{{ t.blogSubtitle }}</p>
            </div>

            <div class="row justify-content-center">
                <div class="col-lg-4 col-md-6">
                    <div class="single-blog-item">
                        <div class="image">
                            <a href="blog-details.html" class="d-block">
                                <img :src="require('../assets/images/blog1.jpg')" alt="image">
                            </a>
                        </div>
                        <div class="content">
                            <h3><a href="blog-details.html">How Do I Know If Someone Is Hacking My Computer?</a></h3>
                            <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.</p>
                            <a href="blog-details.html" class="default-btn">{{ t.readMore }}</a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="single-blog-item">
                        <div class="image">
                            <a href="blog-details.html" class="d-block">
                                <img :src="require('../assets/images/blog3.jpg')" alt="image">
                            </a>
                        </div>
                        <div class="content">
                            <h3><a href="blog-details.html">Why Access Control is Now More Important Than Ever</a></h3>
                            <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.</p>
                            <a href="blog-details.html" class="default-btn">Read More</a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="single-blog-item">
                        <div class="image">
                            <a href="blog-details.html" class="d-block">
                                <img :src="require('../assets/images/blog2.jpg')" alt="image">
                            </a>
                        </div>
                        <div class="content">
                            <h3><a href="blog-details.html">Returning to the Office – a Cyber Security Checklist</a></h3>
                            <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.</p>
                            <a href="blog-details.html" class="default-btn">Read More</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> -->
    <!-- End Blog Section -->

    <!-- Footer Section -->
    <footer class="footer-section pt-100">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="footer-widget">
                        <h3>{{ t.contactInfo }}</h3>

                        <ul class="footer-contact-info">
                            <li><a href="javascript:void(0);">super@proxylink.net</a></li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="footer-widget pl-4">
                        <h3>{{ t.usefulLinks }}</h3>

                        <ul class="links-list">
                            <!-- <li><a href="#">About Us</a></li> -->
                            <!-- <li><a href="#">Features</a></li> -->
                            <li><a href="/faq">{{ t.faq }}</a></li>
                            <!-- <li><a href="#">Blog</a></li>
                            <li><a href="#">Contact</a></li> -->
                        </ul>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="footer-widget">
                        <h3>{{ t.support }}</h3>

                        <ul class="links-list">
                            <li><router-link to="/privacy">{{ t.privacyPolicy }}</router-link></li>
                            <li><router-link to="/service-policy">{{ t.servicePolicy }}</router-link></li>
                            <!-- <li><a href="#">Terms & Conditions</a></li>
                            <li><a href="#">24/7 Support</a></li>
                            <li><a href="#">Contact Us</a></li>
                            <li><a href="#">About Us</a></li> -->
                        </ul>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="footer-widget">
                        <a href="/" class="logo d-inline-block">
                            <img :src="require('../assets/images/homelogo.png')" alt="ProxyLink logo" style="height: 55px; width: auto;">
                        </a>
                        <p>{{ t.welcomeText }}</p>
                        <ul class="social-links">
                          <li><a href="javascript:void(0);"><i class="bx bxl-facebook"></i></a></li>
                          <li><a href="javascript:void(0);"><i class="bx bxl-twitter"></i></a></li>
                          <li><a href="javascript:void(0);"><i class="bx bxl-linkedin"></i></a></li>
                          <li><a href="javascript:void(0);"><i class="bx bxl-instagram"></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="copyright-area">
            <div class="container">
                <p>{{ t.copyright }}</p>
            </div>
        </div>
    </footer>
    <!-- End Footer Section -->

    <div class="go-top" :class="{ 'active': showGoTop }" @click="scrollToTop"><i class='bx bx-up-arrow-alt'></i></div>
    
    <!-- Image Preview Modal -->
    <div v-if="showPreviewModal" class="image-preview-modal" @click="closeImagePreview">
      <div class="modal-content" @click.stop>
        <button class="close-btn" @click="closeImagePreview"><i class='bx bx-x'></i></button>
        <img :src="previewImage" :alt="'Image Preview'" class="preview-img">
      </div>
    </div>
  </div>
</template>

<script>
// Import CSS assets
import '../assets/css/boxicons.min.css'

export default {
  name: 'HomePage',
  inject: ['changeLanguage', 'languageState'],
  data() {
      return {
        showGoTop: false,
        isSticky: false,
        previewImage: '',
        showPreviewModal: false,
        isNavCollapsed: true,
        isMobileMenuOpen: false,
        activeDropdown: null,
        observer: null,
        // 页面文本国际化配置
        i18n: {
          en: {
            home: 'Home',
            services: 'Package',
            serviceDynamic: 'Dynamic residence',
            serviceStatic: 'Static residence',
            portfolio: 'Pricing',
            about: 'About Us',
            features: 'Features',
            team: 'Team',
            pricing: 'Pricing',
            testimonials: 'Testimonials',
            faq: 'FAQ',
            error: '404 Error Page',
            blog: 'Tutorial Center',
            contact: 'Contact',
            discover: 'Discover',
            signIn: 'Sign In',
            signUp: 'Sign Up',
            // Banner content
            bannerTitle: 'YOUR TRUSTED PROXY PARTNER',
            bannerSubtitle: 'Collect The Data Your Project Needs. Power Your Web Scraping & Data Gathering With Our Residential,Mobile And Datacenter Proxies. Gain access to proxies in over 170+countries and 97,500,000+ worldwide clean IP Addresses to access any content at scale.',
            learnMore: 'BUY NOW',
            // Featured Services
            contentManage: 'Fast and reliable',
            oneClick: 'Automatic and Instant Delivery',
            optimizationPlace: '99% Uptime',
            scaleFast: 'Your Best Experience',
            serviceDesc: 'Your trusted choice for speed and dependability.',
            serviceDesconeClick: 'Your time matters, and we’re dedicated to efficiency.',
            serviceDescoptimizationPlace: 'Uninterrupted connectivity you can count on.',
            serviceDescscaleFast: 'At ProxyLink, we are here to ensure your experience is exceptional. ',
            // Features Section
            hungrySuccess: 'Dynamic Residential IP Proxies',
            softwareDev: 'Global IP Network Coverage',
            customSoftware: 'High Performance Proxy Solutions',
            featuresDesc: 'We provide high-quality dynamic residential IP proxy services to help you easily access global network resources while protecting your privacy and security.',
            globalCoverageDesc: 'Our IP proxy network covers over 170+ countries and regions, with millions of dynamic residential IPs, ensuring you can easily access network resources from any region.',
            countries: '170+ Countries & Regions',
            millionsOfIPs: 'Millions of Dynamic Residential IPs',
            autoRotation: 'Automatic IP Rotation',
            uptime: '99.9% Uptime',
            highPerformanceDesc: 'We provide high-performance proxy solutions that support multiple protocols, including HTTP and SOCKS5, ensuring your network connection is secure, stable, fast, and low-latency.',
            supportProtocols: 'Supports HTTP/SOCKS5',
            apiSupport: 'API Integration Support',
            technicalSupport: 'Professional Technical Support',
            flexiblePricing: 'Flexible Pricing Plans',
            // First features box list items
            residentialIP: 'Dynamic Residential IP',
            globalIPCoverage: 'Global IP Coverage',
            highSpeed: 'High Speed & Stable Connection',
            unlimitedBandwidth: 'Unlimited Bandwidth',
            // Portfolio Section
            portfolioTitle: 'What We Do',
            portfolioSubtitle: 'Our Services.',
            portfolioItem1: 'Good Support',
            portfolioDesc1: 'We’re customer-focused, providing excellent support via messages.',
            portfolioItem2: 'High Trust IPs',
            portfolioDesc2: 'We enhance website trust and minimize ban risks for you.',
            portfolioItem3: 'Huge Pool Over 9M+',
            portfolioDesc3: 'Leverage our extensive IP pool to optimize your business operations.',
            portfolioItem4: '100% Privacy',
            portfolioDesc4: 'No logs policy, complete privacy.',
            portfolioItem5: 'Ad Verification',
            portfolioDesc5: 'Advertisers use ProxyLink’s network to sniff out potential ad fraud. They use granular targeting to see their ads on all devices and locations.',
            portfolioItem6: 'SEO Monitoring',
            portfolioDesc6: 'Check your SERP performance with GEO-specific targeting and spy on the competition without them knowing using your own crawler.',
            // Pricing Section
            pricingTitle: 'Pricing Plans',
            pricingSubtitle: 'Dynamic Residential IP Proxies',
            // Pricing Features
            premiumIPs: '7M+ Premium Residential IPs',
            rotatingSticky: 'Rotating & Sticky',
            highTrustIPs: 'High Trust IPs',
            unlimitedThreads: 'Unlimited Threads',
            getNow: 'Get Now',
            // Partner Section
            partnerTitle: 'YOUR IDEAL PROXY SOLUTION FOR ALL NEEDS',
            partnerSubtitle: 'Work Showcase',
            // Blog Section
            blogTitle: 'Our Blog',
            blogSubtitle: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45.',
            readMore: 'Read More',
            // Footer Section
            contactInfo: 'Contact Info',
            usefulLinks: 'Useful Links',
            support: 'Support',
            getStarted: 'Get Started',
            // Footer translations
            privacyPolicy: 'Privacy Policy',
            servicePolicy: 'Service Policy',
            welcomeText: 'Welcome to try our products!',
            copyright: 'ProxyLink. © 2023 All Rights Reserved.'
          },
          zh: {
            home: '首页',
            services: '套餐',
            serviceDynamic: '动态住宅IP代理',
            serviceStatic: '静态住宅IP代理',
            portfolio: '价格',
            about: '关于我们',
            features: '特性',
            team: '团队',
            pricing: '价格',
            testimonials: '客户评价',
            faq: '常见问题',
            error: '404错误页面',
            blog: '博客',
            contact: '联系我们',
            discover: '探索',
            signIn: '登录',
            signUp: '注册',
            // Banner content
            bannerTitle: '您的可信赖代理合作伙伴',
            bannerSubtitle: '收集您项目需要的数据。使用我们的住宅、移动和数据中心代理来强大您的网络爬虫和数据收集。访问超过170个国家/地区和97,500,000个全球清洁IP地址，以大规模访问任何内容。',
            learnMore: '立即 购买',
            // Featured Services
            contentManage: '快速且可靠',
            oneClick: '自动和立即交付',
            optimizationPlace: '99% 可用性',
            scaleFast: '您的最佳体验',
            serviceDesc: '您的速度和依赖度的可信赖选择。',
            serviceDesconeClick: '您的时间很重要，我们致力于效率。',
            serviceDescoptimizationPlace: '您可以依赖的无中断连接。',
            serviceDescscaleFast: '在 ProxyLink，我们致力于确保您获得卓越的体验。',
            // Features Section
            hungrySuccess: '动态住宅IP代理服务',
            softwareDev: '全球覆盖的IP网络',
            customSoftware: '高性能代理解决方案',
            featuresDesc: '我们提供高质量的动态住宅IP代理服务，帮助您轻松访问全球网络资源，保护您的隐私和安全。',
            globalCoverageDesc: '我们的IP代理网络覆盖全球170+国家和地区，拥有数百万个动态住宅IP，确保您能够轻松访问任何地区的网络资源。',
            countries: '170+国家和地区',
            millionsOfIPs: '数百万动态住宅IP',
            autoRotation: '自动IP轮换',
            uptime: '99.9% 正常运行时间',
            highPerformanceDesc: '我们提供高性能的代理解决方案，支持多种协议，包括HTTP和SOCKS5，确保您的网络连接安全稳定，速度快，延迟低。',
            supportProtocols: '支持HTTP/SOCKS5',
            apiSupport: 'API集成支持',
            technicalSupport: '专业技术支持',
            flexiblePricing: '灵活的定价方案',
            // First features box list items
            residentialIP: '动态住宅IP',
            globalIPCoverage: '全球IP覆盖',
            highSpeed: '高速稳定连接',
            unlimitedBandwidth: '无限带宽',
            // Portfolio Section
            portfolioTitle: '我们所做的',
            portfolioSubtitle: '我们的服务。',
            portfolioItem1: '良好的支持',
            portfolioDesc1: '我们以客户为中心，通过消息提供出色的支持。',
            portfolioItem2: '高信任 IP',
            portfolioDesc2: '我们为您增强网站信任度并最大限度地降低封禁风险。',
            portfolioItem3: '超过9M+的超大游泳池',
            portfolioDesc3: '利用我们广泛的 IP 池来优化您的业务运营。',
            portfolioItem4: '100%隐私',
            portfolioDesc4: '没有日志政策，完全隐私。',
            portfolioItem5: '广告验证',
            portfolioDesc5: '广告商使用 ProxyLink 的网络来嗅探潜在的广告欺诈。他们使用精细定位在所有设备和地理位置上查看广告。',
            portfolioItem6: 'SEO监控',
            portfolioDesc6: '通过特定于 GEO 的定位来检查你的 SERP 性能，并在他们不知道使用你自己的爬虫的情况下监视竞争对手。',
            // Pricing Section
            pricingTitle: '价格计划',
            pricingSubtitle: '动态住宅IP代理服务',
            // Pricing Features
            premiumIPs: '700万+优质住宅IP',
            rotatingSticky: '可旋转和粘性IP',
            highTrustIPs: '高信任度IP',
            unlimitedThreads: '无限线程',
            getNow: '立即获取',
            // Partner Section
            partnerTitle: '满足您所有需求的理想代理解决方案',
            partnerSubtitle: '作品展示',
            // Blog Section
            blogTitle: '我们的博客',
            blogSubtitle: '与普遍看法相反，Lorem Ipsum不是简单的随机文本。它起源于45年的一篇古典拉丁文学作品。',
            readMore: '阅读更多',
            // Footer Section
            contactInfo: '联系信息',
            usefulLinks: '有用链接',
            support: '支持',
            getStarted: '开始使用',
            // Footer translations
            privacyPolicy: '隐私政策',
            servicePolicy: '服务政策',
            welcomeText: '欢迎尝试我们的产品！',
            copyright: 'ProxyLink. © 2023 保留所有权利。'
          }
        }
      }
    },
  computed: {
    // 获取当前语言的文本
    t() {
      const lang = this.languageState.currentLanguage;
      return this.i18n[lang] || this.i18n.en;
    }
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll);
    
    // 检查初始滚动位置
    this.handleScroll();
    
    // Initialize Intersection Observer for animations
    this.initObserver();
  },
  beforeDestroy() {
    // 移除滚动事件监听器
    window.removeEventListener('scroll', this.handleScroll);
    
    // Disconnect observer if it exists
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    // Initialize Intersection Observer
    initObserver() {
      const options = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      };
      
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            this.observer.unobserve(entry.target);
          }
        });
      }, options);
      
      // Observe elements with animation classes
        setTimeout(() => {
          document.querySelectorAll('.featured-services-box, .features-box, .portfolio-box, .pricing-plan, .single-blog-item, .partner-item').forEach(el => {
            this.observer.observe(el);
          });
        }, 100);
    },
    handleScroll() {
      // 当滚动超过600px时显示回到顶部按钮
      this.showGoTop = window.scrollY > 600;
      
      // 控制导航栏粘性
      this.isSticky = window.scrollY > 120;
    },
    scrollToTop() {
      // 平滑滚动到顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    openImagePreview(imageUrl) {
      // 打开图片预览
      // 提取文件名，然后使用require处理
      const fileName = imageUrl.split('/').pop();
      this.previewImage = require('../assets/images/' + fileName);
      this.showPreviewModal = true;
      // 阻止页面滚动
      document.body.style.overflow = 'hidden';
    },
    closeImagePreview() {
      // 关闭图片预览
      this.showPreviewModal = false;
      this.previewImage = '';
      // 恢复页面滚动
      document.body.style.overflow = '';
    },
    toggleMobileMenu() {
      // 切换移动端菜单显示/隐藏
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
      
      // 切换按钮样式
      const menuButton = document.getElementById('meanmenu-reveal');
      if (menuButton) {
        menuButton.classList.toggle('active');
      }
    },
    toggleDropdown(event, dropdownName) {
      // 切换下拉菜单显示/隐藏
      event.preventDefault();
      if (!dropdownName) {
        const target = event.currentTarget;
        dropdownName = target.textContent.trim().toLowerCase();
      }
      
      if (this.activeDropdown === dropdownName) {
        this.activeDropdown = null;
      } else {
        this.activeDropdown = dropdownName;
      }
    },
    handleMobileNavClick(targetRoute) {
      // 检查当前路由是否与目标路由相同
      if (this.$route.path === targetRoute) {
        // 关闭移动端菜单
        this.isMobileMenuOpen = false;
        // 重置下拉菜单
        this.activeDropdown = null;
        // 切换按钮样式
        const menuButton = document.getElementById('meanmenu-reveal');
        if (menuButton) {
          menuButton.classList.remove('active');
        }
      }
    },
    setLanguage(lang) {
      // 设置语言并刷新页面
      window.location.href = `?lang=${lang}`;
      this.activeDropdown = null; // 关闭下拉菜单
    }
  }
}
</script>

<style>
/*
@File: Chaz Template Styles

* This file contains the styling for the actual template, this
is the file you need to edit to change the look of the
template.

This files table contents are outlined below>>>>>

*******************************************
*******************************************

** - Default CSS
** - Navbar Area CSS
** - Banner Wrapper Area CSS
** - Featured Services Section CSS
** - Features Section CSS
** - CTA Section CSS
** - Portfolio Section CSS
** - Portfolio Details Section CSS
** - Funfacts Section CSS
** - Team Section CSS
** - Pricing Section CSS
** - Partner Section CSS
** - Blog Section CSS
** - Blog Details Section CSS
** - Testimonials Area CSS
** - Inner Page Banner Section CSS
** - 404 Error Section CSS
** - Contact Section CSS
** - FAQ Section CSS
** - Footer Section CSS
** - Go Top CSS
*/
/*================================================
Default CSS
=================================================*/
@import url("https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200;0,300;0,400;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,600;1,700;1,800;1,900&display=swap");
:root {
  --fontFamily: 'Nunito', sans-serif;
  --mainColor: #4146E6;
  --optionalColor: #6F8BA4;
  --whiteColor: #ffffff;
  --blackColor: #3B566E;
  --fontSize: 16px;
  --transition: .5s;
}

body {
  margin: 0;
  padding: 0;
  color: var(--blackColor);
  font-size: var(--fontSize);
  font-family: var(--fontFamily);
}

.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
  font-weight: 700;
  color: var(--blackColor);
  margin-top: 0;
  margin-bottom: 0.5rem;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.col-lg-6, .col-lg-4, .col-lg-3, .col-lg-2, .col-md-6, .col-md-4, .col-md-3, .col-md-2, .col-sm-6, .col-sm-4, .col-sm-3, .col-6 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

@media (min-width: 0px) {
  .col-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

@media (min-width: 576px) {
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

@media (min-width: 768px) {
  .col-md-2 {
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

@media (min-width: 992px) {
  .col-lg-2 {
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

a {
  text-decoration: none;
  outline: 0 !important;
  color: var(--blackColor);
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

a:hover {
  color: var(--mainColor);
  text-decoration: none;
}

:focus {
  outline: 0 !important;
}

.d-table {
  width: 100%;
  height: 100%;
}

.d-table-cell {
  vertical-align: middle;
}

img {
  max-width: 100%;
  height: auto;
}

p {
  color: var(--optionalColor);
  font-size: var(--fontSize);
  margin-bottom: 15px;
  line-height: 1.8;
}

p:last-child {
  margin-bottom: 0;
}

.ptb-100 {
  padding-top: 100px;
  padding-bottom: 100px;
}

.pt-100 {
  padding-top: 100px;
}

.pb-100 {
  padding-bottom: 100px;
}

.ptb-70 {
  padding-top: 70px;
  padding-bottom: 70px;
}

.pt-70 {
  padding-top: 70px;
}

.pb-70 {
  padding-top: 70px;
  padding-bottom: 70px;
}

.bg-fbfbfb {
  background-color: #fbfbfb;
}

.bg-F7FAFD {
  background-color: #F7FAFD;
}

/*default-btn*/
.default-btn {
  display: inline-block;
  border: none;
  -webkit-box-shadow: 0;
          box-shadow: 0;
  -webkit-transition: var(--transition);
  transition: var(--transition);
  text-decoration: none;
  background-color: var(--mainColor);
  color: var(--whiteColor);
  padding: 12px 35px;
  position: relative;
  z-index: 1;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 700;
}

.default-btn:hover {
  color: var(--whiteColor);
}

.default-btn:hover::before {
  opacity: 0;
  visibility: hidden;
}

.default-btn::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: -1;
  opacity: 1;
  visibility: visible;
  border-radius: 5px;
  -webkit-transition: var(--transition);
  transition: var(--transition);
  background: linear-gradient(135deg, #6a30d1 0%, #5c83e3 100%);
}

/*section-title*/
.section-title {
  text-align: center;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 50px;
}

.section-title h2 {
  font-size: 25px;
  margin-bottom: 12px;
}

.section-title p {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

/*form-control*/
.form-control {
  border: 0;
  padding: 0;
  height: 50px;
  border-radius: 0;
  color: var(--blackColor);
  -webkit-box-shadow: unset !important;
          box-shadow: unset !important;
  border-bottom: 1px solid #ebebeb;
  background-color: transparent !important;
  font-weight: 500;
  font-size: 15px;
}

.form-control::-webkit-input-placeholder {
  color: var(--optionalColor);
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

.form-control:-ms-input-placeholder {
  color: var(--optionalColor);
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

.form-control::-ms-input-placeholder {
  color: var(--optionalColor);
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

.form-control::placeholder {
  color: var(--optionalColor);
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

.form-control:focus {
  border-color: var(--mainColor);
}

.form-control:focus::-webkit-input-placeholder {
  opacity: 0;
}

.form-control:focus:-ms-input-placeholder {
  opacity: 0;
}

.form-control:focus::-ms-input-placeholder {
  opacity: 0;
}

.form-control:focus::placeholder {
  opacity: 0;
}

textarea.form-control {
  padding-top: 10px;
}

/*================================================
Navbar Area CSS
=================================================*/
.navbar-area {
  top: 0;
  left: 0;
  padding: 0;
  width: 100%;
  height: auto;
  z-index: 999;
  position: absolute;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: transparent;
}

.navbar-area.is-sticky {
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  position: fixed;
  background-color: var(--whiteColor) !important;
  -webkit-box-shadow: 0 0.25rem 0.25rem 0 rgba(15, 30, 150, 0.03);
          box-shadow: 0 0.25rem 0.25rem 0 rgba(15, 30, 150, 0.03);
  -webkit-animation: fadeInDown 500ms ease-in-out 0s normal none 1 running;
          animation: fadeInDown 500ms ease-in-out 0s normal none 1 running;
}

/* Navbar Toggler Styles */
.navbar-toggler {
  display: none;
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  transition: box-shadow 0.15s ease-in-out;
  margin-left: auto;
  cursor: pointer;
}

.navbar-toggler:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: no-repeat center center;
  background-size: 100% 100%;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}

/* Show navbar toggler on small screens */
@media (max-width: 767px) {
  .navbar-toggler {
    display: block;
  }
}

/* Animation keyframes */
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
  }
}

.template-responsive-navbar {
  display: none;
}

.template-navbar {
  display: block;
  width: 100%;
}

.template-navbar .navbar {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;
}

/* Logo styling */
.template-navbar .logo img,
.template-responsive-menubar .logo img,
.footer-widget .logo img {
  max-height: 55px;
  height: 55px;
  width: auto;
  object-fit: contain;
}

.template-navbar .navbar-brand img {
  max-height: 55px;
  height: 55px;
  width: auto;
  object-fit: contain;
}

/* Dropdown menu styling */
.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 999;
  min-width: 200px;
  padding: 0;
  margin: 0;
  background-color: var(--whiteColor);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.template-navbar .navbar .navbar-nav .nav-item:hover .dropdown-menu {
  display: block;
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li {
  position: relative;
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li a {
  padding: 10px 15px;
  font-size: 14px;
  color: var(--optionalColor);
  display: block;
  text-decoration: none;
  border-bottom: 1px solid #f0f0f0;
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li:last-child a {
  border-bottom: none;
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li a:hover {
  background-color: var(--mainColor);
  color: var(--whiteColor);
  border-bottom-color: var(--mainColor);
}

/* Sub-dropdown menu */
.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li .dropdown-menu {
  left: 100%;
  top: 0;
  margin-left: 0;
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li:hover .dropdown-menu {
  display: block;
}

/* Others option styling */
.template-navbar .navbar .others-option {
  display: flex;
  align-items: center;
}

.template-navbar .navbar .others-option .item {
  margin-left: 15px;
}

/* Responsive adjustments */
@media (max-width: 991px) {
  .template-navbar {
    display: none;
  }
  
  .template-responsive-navbar {
    display: block;
  }
}

/* Mobile Menu Styles */
.mean-nav {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: auto;
  height: auto;
  max-height: 80vh;
  background-color: rgba(255, 255, 255, 0.95);
  z-index: 9999;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  opacity: 0;
  visibility: hidden;
  transform: translateY(-20px);
  transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 2px solid #f0f0f0;
}

.mean-nav.mean-show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.mobile-menu-container {
  max-width: 400px;
  width: 100%;
  margin: 0 auto;
  padding-top: 80px;
  /* padding-bottom: 20px; */
  box-sizing: border-box;
  overflow: hidden;
}

.template-responsive-menubar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  position: relative;
  z-index: 10000;
}

.meanmenu-reveal {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 10001;
}

.meanmenu-reveal span {
  display: block;
  width: 25px;
  height: 3px;
  background-color: var(--blackColor);
  position: relative;
  transition: all 0.3s ease;
}

.meanmenu-reveal span:before,
.meanmenu-reveal span:after {
  content: '';
  position: absolute;
  width: 25px;
  height: 3px;
  background-color: var(--blackColor);
  transition: all 0.3s ease;
}

.meanmenu-reveal span:before {
  top: -8px;
}

.meanmenu-reveal span:after {
  top: 8px;
}

/* Change button to × when menu is open */
.meanmenu-reveal.active span {
  background-color: transparent;
}

.meanmenu-reveal.active span:before {
  top: 0;
  transform: rotate(45deg);
}

.meanmenu-reveal.active span:after {
  top: 0;
  transform: rotate(-45deg);
}

/* Mobile Menu Navbar Styles */
.mobile-menu-container .navbar-nav {
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 0;
  margin: 0 0 20px 0;
  list-style: none;
  box-sizing: border-box;
  overflow-y: auto;
  max-height: calc(80vh - 180px);
}

.mobile-menu-container .navbar-nav .nav-item {
  margin: 0;
  width: 100%;
  box-sizing: border-box;
}

/* Mobile Menu Navbar Styles */
.mobile-menu-container .navbar-nav .nav-item a {
  padding: 15px 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--blackColor);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  width: 100%;
  box-sizing: border-box;
}

/* Style for dropdown icon */
.mobile-menu-container .navbar-nav .nav-item a .dropdown-icon {
  margin-left: 10px;
  font-size: 16px;
  transition: transform 0.3s ease;
}

/* Add active class to parent when dropdown is open */
.mobile-menu-container .navbar-nav .nav-item:has(.dropdown-menu.show) > a.dropdown-toggle .dropdown-icon {
  transform: rotate(45deg);
}

.mobile-menu-container .navbar-nav .nav-item a:hover {
  color: var(--mainColor);
}

.mobile-menu-container .navbar-nav .nav-item a.active {
  color: var(--mainColor);
}

/* Mobile Language Switcher Styles */
.mobile-menu-container .navbar-nav .nav-item .language-switcher {
  padding: 15px 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--blackColor);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  background: none;
  border: none;
  cursor: pointer;
  transition: color 0.3s ease;
  width: 100%;
  text-align: left;
}

.mobile-menu-container .navbar-nav .nav-item .language-switcher:hover {
  color: var(--mainColor);
}

/* Mobile Dropdown Menu */
.mobile-menu-container .navbar-nav .nav-item .dropdown-menu {
  position: static;
  box-shadow: none;
  border: none;
  padding: 0;
  margin: 0;
  background-color: transparent;
  width: 100%;
  max-width: 100%;
  opacity: 0;
  visibility: hidden;
  max-height: 0;
  overflow: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease, max-height 0.3s ease;
  box-sizing: border-box;
}

.mobile-menu-container .navbar-nav .nav-item .dropdown-menu.show {
  opacity: 1;
  visibility: visible;
  max-height: 500px;
}

.mobile-menu-container .navbar-nav .nav-item .dropdown-menu li a {
  padding: 10px 0 10px 20px;
  font-size: 14px;
  font-weight: 500;
  border-bottom: none;
  color: var(--optionalColor);
}

.mobile-menu-container .navbar-nav .nav-item .dropdown-menu li a:hover {
  color: var(--mainColor);
  background-color: transparent;
}

.mobile-menu-container .navbar-nav .nav-item .dropdown-menu .dropdown-menu li a {
  padding-left: 40px;
}

/* Mobile Menu Toggle Animation */
.is-mobile-menu-open .meanmenu-reveal span {
  background-color: transparent;
}

.is-mobile-menu-open .meanmenu-reveal span:before {
  transform: rotate(45deg);
  top: 0;
}

.is-mobile-menu-open .meanmenu-reveal span:after {
  transform: rotate(-45deg);
  top: 0;
}

.template-navbar .navbar .navbar-brand {
  font-size: inherit;
  line-height: 1;
  padding: 0;
  display: inline-block;
}

.template-navbar .navbar .navbar-brand .logo-text{
  -webkit-text-fill-color: transparent;
  align-items: center;
  font-family: "Poppins", "Inter", "Roboto", sans-serif;
  background: -webkit-gradient(linear, left top, left bottom, from(#428bf3), to(#3e30ff));
  -webkit-background-clip: text;
  background-clip: text;
  display: flex;
  flex-shrink: 0;
  font-size: 25px;
  font-weight: 700;
  height: 1.9rem;
  justify-content: space-between;
  /* margin-right: 35px; */
  text-align: center;
  cursor: pointer;
}

.template-navbar .navbar ul {
  padding-left: 0;
  list-style-type: none;
  margin-bottom: 0;
}

.template-navbar .navbar .navbar-nav {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: row;
}

.template-navbar .navbar .navbar-nav .nav-item {
  position: relative;
  margin-left: 14px;
  margin-right: 14px;
}

.template-navbar .navbar .navbar-nav .nav-item a {
  color: var(--optionalColor);
  font-weight: 600;
  font-size: var(--fontSize);
  padding-left: 0;
  padding-right: 0;
  padding-top: 20px;
  padding-bottom: 20px;
  display: block;
  text-decoration: none;
}

.template-navbar .navbar .navbar-nav .nav-item a:hover, .template-navbar .navbar .navbar-nav .nav-item a:focus, .template-navbar .navbar .navbar-nav .nav-item a.active {
  color: var(--mainColor);
}

/* Language Switcher Styles */
.template-navbar .navbar .navbar-nav .nav-item .language-switcher {
  color: var(--optionalColor);
  font-weight: 600;
  font-size: var(--fontSize);
  padding: 20px 0;
  display: block;
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
  transition: color 0.3s ease;
}

.template-navbar .navbar .navbar-nav .nav-item .language-switcher:hover {
  color: var(--mainColor);
}

/* Language Option Styles */
.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu .language-option {
  padding: 10px 15px;
  font-size: 14px;
  color: var(--optionalColor);
  display: block;
  text-decoration: none;
  border-bottom: 1px solid #f0f0f0;
  background: none;
  border: none;
  cursor: pointer;
  width: 100%;
  text-align: left;
  font-weight: 500;
  transition: all 0.3s ease;
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu .language-option:hover {
  background-color: var(--mainColor);
  color: var(--whiteColor);
  border-bottom-color: var(--mainColor);
  transition: all 0.3s ease;
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu .nav-item:last-child .language-option {
  border-bottom: none;
}

/* Mobile Language Option Styles */
.mobile-menu-container .navbar-nav .nav-item .dropdown-menu .language-option {
  padding: 10px 0 10px 20px;
  font-size: 14px;
  font-weight: 500;
  border-bottom: none;
  color: var(--optionalColor);
  background: none;
  border: none;
  cursor: pointer;
  width: 100%;
  text-align: left;
  transition: all 0.3s ease;
}

.mobile-menu-container .navbar-nav .nav-item .dropdown-menu .language-option:hover {
  color: var(--whiteColor);
  background-color: var(--mainColor);
  border-radius: 4px;
  margin: 0 10px;
  padding-left: 10px;
  transition: all 0.3s ease;
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-toggle {
  padding-right: 17px;
  cursor: pointer;
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-toggle::after {
  display: none;
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-toggle::before {
  content: "\e9ac";
  position: absolute;
  right: -4px;
  top: 17px;
  font-weight: 300;
  font-size: 20px;
  font-family: 'boxicons';
}

.navbar-expand-md {
  flex-wrap: nowrap;
  justify-content: flex-start;
}

.navbar-expand-md .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-light .navbar-brand {
  color: rgba(0,0,0,.9);
}

.navbar-light .navbar-nav .nav-link {
  color: rgba(0,0,0,.55);
}

.navbar-light .navbar-nav .nav-link.active, .navbar-light .navbar-nav .show > .nav-link {
  color: rgba(0,0,0,.9);
}

.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0,0,0,.7);
}

.template-navbar .navbar .navbar-nav .nav-item:last-child {
  margin-right: 0;
}

.template-navbar .navbar .navbar-nav .nav-item:first-child {
  margin-left: 0;
}

.template-navbar .navbar .navbar-nav .nav-item:hover a, .template-navbar .navbar .navbar-nav .nav-item.active a {
  color: var(--mainColor);
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu {
  border: none;
  top: 64px;
  left: 0;
  z-index: 99;
  opacity: 0;
  width: 250px;
  display: none;
  border-radius: 0;
  padding: 0;
  margin-top: 15px;
  position: absolute;
  visibility: hidden;
  background: var(--whiteColor);
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  -webkit-box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
          box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li {
  margin: 0;
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li a {
  display: block;
  padding: 10px 20px;
  position: relative;
  color: var(--optionalColor);
  border-top: 1px dashed #eeeeee;
  font-size: 15px;
  font-weight: 600;
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li a i {
  margin: 0;
  position: absolute;
  top: 50%;
  font-size: 20px;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
  right: 15px;
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li a:hover, .template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li a:focus, .template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li a.active {
  color: var(--whiteColor);
  background-color: var(--mainColor);
  border-top-color: var(--mainColor);
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li .dropdown-menu {
  top: 0;
  opacity: 0;
  left: -250px;
  margin-top: 15px;
  visibility: hidden;
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li .dropdown-menu li a {
  color: var(--optionalColor);
  border-top-color: #eeeeee;
  background-color: transparent;
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li .dropdown-menu li a:hover, .template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li .dropdown-menu li a:focus, .template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li .dropdown-menu li a.active {
  color: var(--whiteColor);
  background-color: var(--mainColor);
  border-top-color: var(--mainColor);
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li .dropdown-menu li .dropdown-menu {
  top: 0;
  opacity: 0;
  left: 250px;
  visibility: hidden;
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li .dropdown-menu li .dropdown-menu li a {
  color: var(--optionalColor);
  border-top-color: #eeeeee;
  background-color: transparent;
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li .dropdown-menu li .dropdown-menu li a:hover, .template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li .dropdown-menu li .dropdown-menu li a:focus, .template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li .dropdown-menu li .dropdown-menu li a.active {
  color: var(--whiteColor);
  background-color: var(--mainColor);
  border-top-color: var(--mainColor);
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li .dropdown-menu li .dropdown-menu li.active a {
  color: var(--whiteColor);
  background-color: var(--mainColor);
  border-top-color: var(--mainColor);
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li .dropdown-menu li .dropdown-menu li:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li .dropdown-menu li.active a {
  color: var(--whiteColor);
  background-color: var(--mainColor);
  border-top-color: var(--mainColor);
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li .dropdown-menu li:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li.active a {
  color: var(--whiteColor);
  background-color: var(--mainColor);
  border-top-color: var(--mainColor);
}

.template-navbar .navbar .navbar-nav .nav-item .dropdown-menu li:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
  margin-top: 0;
}

.template-navbar .navbar .navbar-nav .nav-item:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
  margin-top: 0;
}

.template-navbar .navbar .others-option .item {
  margin-left: 20px;
}

.template-navbar .navbar .others-option .item:first-child {
  margin-left: 0;
}

.template-navbar .navbar .others-option .item:nth-child(1) .default-btn::before {
  background: var(--blackColor);
}

@media only screen and (max-width: 991px) {
  .navbar-area {
    /* border-bottom: 1px solid #eeeeee; */
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .navbar-area.is-sticky {
    padding-top: 20px;
    padding-bottom: 15px;
  }
  .template-responsive-navbar {
    display: block;
  }
  .template-responsive-navbar .template-responsive-menubar {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  
  .template-responsive-menubar .logo {
    flex: 1;
  }

  .template-responsive-menubar .logo .logo-text {
    -webkit-text-fill-color: transparent;
    align-items: center;
    background: -webkit-gradient(linear, left top, left bottom, from(#428bf3), to(#3e30ff));
    -webkit-background-clip: text;
    background-clip: text;
    display: flex;
    flex-shrink: 0;
    font-size: 25px;
    font-weight: 700;
    height: 1.9rem;
    justify-content: space-between;
    /* margin-right: 35px; */
    text-align: center;
    cursor: pointer;
  }
  
  .template-responsive-menubar .navbar-toggler {
    display: block;
  }
  

  .template-responsive-navbar .template-responsive-menubar.mean-container .mean-nav {
    margin-top: 40px;
  }
  .template-responsive-navbar .template-responsive-menubar.mean-container .mean-nav ul {
    font-size: 15px;
  }
  .template-responsive-navbar .template-responsive-menubar.mean-container .mean-nav ul li a.active {
    color: var(--mainColor);
  }
  .template-responsive-navbar .template-responsive-menubar.mean-container .mean-nav ul li li a {
    font-size: 15px;
  }
  .template-responsive-navbar .template-responsive-menubar.mean-container .navbar-nav {
    overflow-y: scroll;
    height: 306px;
    -webkit-box-shadow: 0 7px 13px 0 rgba(0, 0, 0, 0.1);
            box-shadow: 0 7px 13px 0 rgba(0, 0, 0, 0.1);
  }
  .template-responsive-navbar .mean-container a.meanmenu-reveal {
    color: var(--blackColor);
  }
  .template-responsive-navbar .mean-container a.meanmenu-reveal span {
    background: var(--blackColor);
  }
  .template-responsive-navbar .dropdown-toggle::after {
    display: none !important;
  }
  .template-responsive-navbar .others-option {
    display: flex !important;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
    position: static;
  }
  .template-responsive-navbar .others-option .item {
    margin-left: 0;
    width: 100%;
  }
  .template-responsive-navbar .others-option .item:first-child {
    margin-left: 0;
  }
  .template-responsive-navbar .others-option .default-btn {
    width: 100%;
    text-align: center;
    padding: 14px 35px;
    font-size: 16px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  .template-responsive-navbar .others-option .item:nth-child(1) .default-btn {
    background-color: var(--whiteColor);
    color: var(--mainColor);
    border: 2px solid var(--mainColor);
  }
  .template-responsive-navbar .others-option .item:nth-child(1) .default-btn::before {
    background: linear-gradient(135deg, var(--mainColor) 0%, var(--secondaryColor) 100%);
  }
  .template-responsive-navbar .others-option .item:nth-child(2) .default-btn {
    background-color: var(--mainColor);
    color: var(--whiteColor);
  }
  .template-responsive-navbar .others-option .item:nth-child(2) .default-btn::before {
    background: linear-gradient(135deg, var(--secondaryColor) 0%, var(--mainColor) 100%);
  }
  
  .template-responsive-navbar .logo {
    position: relative;
    width: 60%;
    z-index: 999;
  }
  .template-navbar {
    display: none;
  }
  .responsive-others-option {
    display: block;
  }
}

/*================================================
Banner Wrapper Area CSS
=================================================*/
.banner-wrapper {
  position: relative;
  z-index: 1;
  background-color: rgb(247, 250, 253);
  padding-top: 200px;
  padding-bottom: 100px;
  overflow: hidden;
  animation: backgroundPulse 8s ease-in-out infinite;
}

@keyframes backgroundPulse {
  0%, 100% {
    background-color: rgb(247, 250, 253);
  }
  50% {
    background-color: rgba(65, 70, 230, 0.05);
  }
}

.banner-wrapper::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  /* background-image: url(../assets/images/cta-bg.jpg); */
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.1;
  z-index: -1;
}

.banner-content {
  padding-right: 15px;
  animation: fadeInUp 1s ease-out;
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.banner-content h1 {
  font-size: 30px;
  line-height: 1.4;
  margin-bottom: 20px;
  font-weight: 700;
  color: var(--blackColor);
  animation: fadeInUp 0.8s ease-out 0.2s both;
  position: relative;
}

.banner-content h1::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -10px;
  width: 60px;
  height: 4px;
  background: linear-gradient(135deg, #4146E6 0%, #6a30d1 100%);
  animation: growWidth 1s ease-out 0.5s both;
}

@keyframes growWidth {
  0% {
    width: 0;
  }
  100% {
    width: 60px;
  }
}

.banner-content p {
  max-width: 400px;
  font-size: var(--fontSize);
  line-height: 1.8;
  margin-bottom: 25px;
  color: var(--optionalColor);
  animation: fadeInUp 0.8s ease-out 0.4s both;
}

.banner-content .default-btn {
  margin-top: 15px;
  display: inline-block;
  text-decoration: none;
  animation: fadeInUp 0.8s ease-out 0.6s both;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.banner-content .default-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(65, 70, 230, 0.3);
}

.banner-image {
  padding-left: 15px;
  margin-bottom: -30px;
  position: relative;
  z-index: 2;
  opacity: 1;
  animation: fadeInRight 1s ease-out 0.8s both;
}

@keyframes fadeInRight {
  0% {
    opacity: 0;
    transform: translateX(30px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.banner-image .image {
  margin-bottom: 15px;
  position: relative;
  overflow: hidden;
}

.banner-image .image img {
  width: 100%;
  height: auto;
  border-radius: 15px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
  transform: scale(1);
}

/* Staggered animation for images */
.banner-image .col-lg-6:nth-child(1) .image img {
  animation: slideInUp 0.8s ease-out 1s both;
}

.banner-image .col-lg-6:nth-child(2) .image img {
  animation: slideInUp 0.8s ease-out 1.2s both;
}

.banner-image .col-lg-6:nth-child(3) .image img {
  animation: slideInUp 0.8s ease-out 1.4s both;
}

.banner-image .col-lg-6:nth-child(4) .image img {
  animation: slideInUp 0.8s ease-out 1.6s both;
}

@keyframes slideInUp {
  0% {
    opacity: 0;
    transform: translateY(50px) scale(0.9);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.banner-image .image:hover img {
  transform: translateY(-10px) scale(1.02);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
}

.banner-image .col-lg-6:nth-child(1) .image img {
  border-radius: 15px 0 0 0;
}

.banner-image .col-lg-6:nth-child(2) .image img {
  border-radius: 0 15px 0 0;
}

.banner-image .col-lg-6:nth-child(3) .image img {
  border-radius: 0 0 0 15px;
}

.banner-image .col-lg-6:nth-child(4) .image img {
  border-radius: 0 0 15px 0;
}

/* Background shape styling */
.background-shape {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.background-shape .circle1,
.background-shape .circle2,
.background-shape .circle3,
.background-shape .circle4 {
  display: block;
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(65, 70, 230, 0.1) 0%, rgba(106, 48, 209, 0.1) 100%);
  animation: float 6s ease-in-out infinite;
}

.background-shape .circle1 {
  width: 200px;
  height: 200px;
  top: -50px;
  left: -50px;
  animation-delay: 0s;
}

.background-shape .circle2 {
  width: 150px;
  height: 150px;
  top: 50%;
  right: -30px;
  animation-delay: 1.5s;
}

.background-shape .circle3 {
  width: 100px;
  height: 100px;
  bottom: 50px;
  left: 10%;
  animation-delay: 3s;
}

.background-shape .circle4 {
  width: 120px;
  height: 120px;
  bottom: 150px;
  right: 20%;
  animation-delay: 4.5s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

/* Responsive adjustments */
@media (max-width: 767px) {
  .banner-wrapper {
    padding-top: 150px;
    padding-bottom: 70px;
  }
  
  .banner-content {
    padding-right: 0;
    text-align: center;
  }
  
  .banner-content h1 {
    font-size: 24px;
    text-align: center;
  }
  
  .banner-content p {
    text-align: center;
    max-width: 100%;
  }
  
  .banner-image {
    margin-bottom: 0;
    padding-left: 0;
    margin-top: 30px;
  }
  
  /* Features Section Mobile */
  .features-content {
    padding-right: 0;
    text-align: center;
  }
  
  .features-content h2 {
    text-align: center;
  }
  
  .features-content p {
    text-align: center;
  }
  
  .features-content .list {
    text-align: center;
    padding-left: 0;
  }
  
  .features-content .list li {
    padding-left: 0;
    text-align: center;
    display: block;
  }
  
  .features-content .list li i {
    position: static;
    margin-right: 8px;
    display: inline-block;
    vertical-align: middle;
  }
  
  .features-content .list li a {
    display: inline-block;
    vertical-align: middle;
  }
  
  .features-image {
    padding-left: 0;
    margin-top: 30px;
    text-align: center;
  }
}

/* Featured Services Section */
.featured-services-section {
  padding: 100px 0;
  background-color: var(--whiteColor);
}

.featured-services-section.bg-F7FAFD {
  background-color: #F7FAFD;
}

.featured-services-section.pb-70 {
  padding-bottom: 70px;
}

.featured-services-section .row > div {
  display: flex;
  flex-direction: column;
}

.featured-services-box {
  text-align: center;
  padding: 30px 20px;
  border-radius: 5px;
  margin-bottom: 30px;
  background-color: var(--whiteColor);
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.featured-services-box.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* Staggered animation for service boxes */
.featured-services-section .row > div:nth-child(1) .featured-services-box {
  transition-delay: 0.1s;
}

.featured-services-section .row > div:nth-child(2) .featured-services-box {
  transition-delay: 0.2s;
}

.featured-services-section .row > div:nth-child(3) .featured-services-box {
  transition-delay: 0.3s;
}

.featured-services-section .row > div:nth-child(4) .featured-services-box {
  transition-delay: 0.4s;
}

.featured-services-section.bg-F7FAFD .featured-services-box {
  background-color: var(--whiteColor);
}

.featured-services-section.bg-F7FAFD .featured-services-box i {
  background-color: #F7FAFD;
  color: var(--mainColor);
}

.featured-services-section.bg-F7FAFD .featured-services-box:hover i {
  color: var(--whiteColor);
  background-color: var(--mainColor);
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 10px 20px rgba(65, 70, 230, 0.3);
  border-radius: 10px;
}

.featured-services-box i {
  display: inline-block;
  margin-bottom: 30px;
  width: 70px;
  height: 70px;
  line-height: 70px;
  color: var(--mainColor);
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
  border-radius: 50%;
  font-size: 35px;
  background-color: #F7FAFD;
  transform: scale(1);
}

.featured-services-box h3 {
  font-size: 20px;
  margin-bottom: 12px;
  font-weight: 700;
  transition: var(--transition);
}

.featured-services-box h3 a {
  color: var(--blackColor);
  text-decoration: none;
  transition: var(--transition);
}

.featured-services-box h3 a:hover {
  color: var(--mainColor);
}

.featured-services-box p {
  margin-bottom: 0;
  color: var(--optionalColor);
  font-size: 14px;
  line-height: 1.6;
}

.featured-services-box:hover i {
  color: var(--whiteColor);
  border-radius: 10px;
  background-color: var(--mainColor);
}

.featured-services-box:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
  border-radius: 8px;
}

/* Features Section */
.features-section {
  padding: 100px 0;
  background-color: var(--whiteColor);
}

.features-box {
  margin-top: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Animation for features content and image */
.features-box .features-content,
.features-box .features-image {
  opacity: 0;
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.features-box:nth-child(odd) .features-content {
  transform: translateX(-30px);
  transition-delay: 0.2s;
}

.features-box:nth-child(odd) .features-image {
  transform: translateX(30px);
  transition-delay: 0.4s;
}

.features-box:nth-child(even) .features-content {
  transform: translateX(30px);
  transition-delay: 0.2s;
}

.features-box:nth-child(even) .features-image {
  transform: translateX(-30px);
  transition-delay: 0.4s;
}

/* Animation for list items */
.features-content .list li {
  opacity: 0;
  transform: translateX(-20px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.features-content .list li:nth-child(1) {
  transition-delay: 0.6s;
}

.features-content .list li:nth-child(2) {
  transition-delay: 0.8s;
}

.features-content .list li:nth-child(3) {
  transition-delay: 1s;
}

.features-content .list li:nth-child(4) {
  transition-delay: 1.2s;
}

/* Trigger animations when animate-in class is added */
.features-box.animate-in .features-content,
.features-box.animate-in .features-image,
.features-box.animate-in .features-content .list li {
  opacity: 1;
  transform: translateX(0);
}

.features-box:first-child {
  margin-top: 0;
}

.features-content {
  padding-right: 30px;
}

.features-content h2 {
  font-size: 36px;
  line-height: 1.3;
  margin-bottom: 20px;
  font-weight: 700;
}

.features-content p {
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 25px;
  color: var(--optionalColor);
}

.features-content .list {
  padding-left: 0;
  list-style-type: none;
  margin-bottom: 30px;
  display: inline-block;
}

.features-content .list li {
  position: relative;
  margin-bottom: 15px;
  padding-left: 30px;
  font-weight: 600;
  color: var(--optionalColor);
}

.features-content .list li i {
  position: absolute;
  left: 0;
  top: 5px;
  color: var(--mainColor);
  font-size: 20px;
}

.features-content .list li a {
  color: var(--optionalColor);
  text-decoration: none;
  transition: all 0.3s ease;
}

.features-content .list li a:hover {
  color: var(--mainColor);
}

.features-image {
  padding-left: 30px;
}

.features-image img {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
}

/* CTA Section */
.cta-section {
  padding: 100px 0;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url(../assets/images/cta-bg.jpg);
  position: relative;
  z-index: 1;
}

.cta-section::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(65, 70, 230, 0.85);
  z-index: -1;
}

.cta-content {
  text-align: center;
  color: var(--whiteColor);
}

.cta-content h2 {
  font-size: 40px;
  line-height: 1.3;
  margin-bottom: 20px;
  color: var(--whiteColor);
}

.cta-content p {
  font-size: 18px;
  line-height: 1.8;
  margin-bottom: 30px;
  color: rgba(255, 255, 255, 0.9);
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.cta-content .default-btn {
  margin-top: 20px;
  background-color: var(--whiteColor);
  color: var(--mainColor);
  border: none;
  padding: 15px 40px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 50px;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
}

.cta-content .default-btn:hover {
  background-color: var(--blackColor);
  color: var(--whiteColor);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.background-shape .circle1 {
  width: 1700px;
  height: 1700px;
  border-radius: 50%;
  position: absolute;
  z-index: -30;
  top: -1100px;
  right: -1100px;
  background: white;
}

.background-shape .circle2 {
  width: 1700px;
  height: 1700px;
  border-radius: 50%;
  position: absolute;
  z-index: -20;
  top: -850px;
  right: -850px;
  background: rgba(0, 0, 0, 0.01);
}

.background-shape .circle3 {
  width: 1200px;
  height: 1200px;
  border-radius: 50%;
  position: absolute;
  z-index: -10;
  top: -600px;
  right: -600px;
  background: rgba(0, 0, 0, 0.01);
}

.background-shape .circle4 {
  width: 700px;
  height: 700px;
  border-radius: 50%;
  position: absolute;
  z-index: -10;
  top: -350px;
  right: -350px;
  background: rgba(0, 0, 0, 0.01);
}

.background-shape .circle5 {
  width: 1700px;
  height: 1700px;
  border-radius: 50%;
  position: absolute;
  z-index: -30;
  top: -1100px;
  left: -1100px;
  background: white;
}

.background-shape .circle6 {
  width: 1700px;
  height: 1700px;
  border-radius: 50%;
  position: absolute;
  z-index: -20;
  top: -850px;
  left: -850px;
  background: rgba(0, 0, 0, 0.02);
}

.background-shape .circle7 {
  width: 1200px;
  height: 1200px;
  border-radius: 50%;
  position: absolute;
  z-index: -10;
  top: -600px;
  left: -600px;
  background: white;
}

.background-shape .circle8 {
  width: 700px;
  height: 700px;
  border-radius: 50%;
  position: absolute;
  z-index: -10;
  top: -350px;
  left: -350px;
  background: rgba(0, 0, 0, 0.02);
}

/*================================================
Featured Services Section CSS
=================================================*/
.featured-services-section.bg-F7FAFD .featured-services-box {
  background-color: var(--whiteColor);
}

.featured-services-section.bg-F7FAFD .featured-services-box i {
  background-color: #F7FAFD;
  color: var(--mainColor);
}

.featured-services-section.bg-F7FAFD .featured-services-box:hover i {
  color: var(--whiteColor);
  background-color: var(--mainColor);
}

.featured-services-box {
  text-align: center;
  padding: 30px 20px;
  border-radius: 5px;
  margin-bottom: 30px;
  background-color: #F7FAFD;
}

.featured-services-box i {
  display: inline-block;
  margin-bottom: 30px;
  width: 70px;
  height: 70px;
  line-height: 70px;
  color: var(--mainColor);
  -webkit-transition: var(--transition);
  transition: var(--transition);
  border-radius: 50%;
  font-size: 35px;
  background-color: var(--whiteColor);
}

.featured-services-box h3 {
  font-size: 20px;
  margin-bottom: 12px;
}

.featured-services-box:hover i {
  color: var(--whiteColor);
  border-radius: 10px;
  background-color: var(--mainColor);
}

/*================================================
Features Section CSS
=================================================*/
.features-box {
  margin-top: 100px;
}

.features-box:first-child {
  margin-top: 0;
}

.features-box:nth-child(2) .features-content, .features-box:nth-child(4) .features-content, .features-box:nth-child(6) .features-content, .features-box:nth-child(8) .features-content {
  padding-left: 0;
  padding-right: 15px;
}

.features-box:nth-child(2) .features-image, .features-box:nth-child(4) .features-image, .features-box:nth-child(6) .features-image, .features-box:nth-child(8) .features-image {
  padding-left: 15px;
  padding-right: 0;
}

.features-image {
  padding-right: 15px;
}

.features-content {
  padding-left: 15px;
}

.features-content h2 {
  font-size: 25px;
  margin-bottom: 12px;
}

.features-content .list {
  padding-left: 0;
  list-style-type: none;
  margin-bottom: 0;
  margin-top: 20px;
}

.features-content .list li {
  position: relative;
  margin-bottom: 12px;
  padding-left: 25px;
  font-weight: 600;
  color: var(--optionalColor);
}

.features-content .list li a {
  color: var(--optionalColor);
}

.features-content .list li a:hover {
  color: var(--mainColor);
}

.features-content .list li i {
  position: absolute;
  left: 0;
  top: 3px;
  color: var(--mainColor);
}

.features-content .list li:last-child {
  margin-bottom: 0;
}

.about-area.banner-wrapper {
  background-color: transparent;
  padding-top: 100px;
  padding-bottom: 0;
}

.about-area .banner-content p {
  max-width: 100%;
}

/*================================================
Portfolio Section CSS
=================================================*/
.portfolio-box {
  margin-bottom: 30px;
  position: relative;
  overflow: hidden;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  height: 280px;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  cursor: pointer;
}

.portfolio-box::before {
  z-index: 1;
  content: '';
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0.9;
  visibility: visible;
  position: absolute;
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  background: linear-gradient(135deg, var(--mainColor) 0%, #6a30d1 100%);
  border-radius: 12px;
}

.portfolio-box::after {
  content: '';
  position: absolute;
  top: -20px;
  right: -20px;
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  z-index: 1;
}

/* Add second decorative element */
.portfolio-box .content::after {
  content: '';
  position: absolute;
  bottom: -30px;
  left: -30px;
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 50%;
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  z-index: -1;
}

.portfolio-box .content {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  right: 0;
  height: auto;
  padding: 40px 30px;
  text-align: center;
  opacity: 1;
  visibility: visible;
  z-index: 2;
}

.portfolio-box .content h3 {
  margin-bottom: 15px;
  color: var(--whiteColor);
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: capitalize;
}

.portfolio-box .content .category span {
  display: inline-block;
  color: var(--whiteColor);
  opacity: 0.95;
  font-size: 16px;
  line-height: 1.6;
  font-weight: 500;
}

.portfolio-box:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.18);
}

.portfolio-box:hover::before {
  opacity: 1;
  transform: scale(1.05);
  background: linear-gradient(135deg, #6a30d1 0%, var(--mainColor) 100%);
}

.portfolio-box:hover::after {
  transform: scale(1.5);
  opacity: 0.6;
}

.portfolio-box:hover .content::after {
  transform: scale(1.3);
  opacity: 0.4;
}

.portfolio-box:hover .content {
  transform: translateY(-50%) scale(1.05);
}

/* Animation trigger for portfolio boxes */
.portfolio-box.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* Enhanced staggered animation for portfolio boxes */
.portfolio-sction .row > div:nth-child(1) .portfolio-box {
  transition-delay: 0.1s;
}

.portfolio-sction .row > div:nth-child(2) .portfolio-box {
  transition-delay: 0.2s;
}

.portfolio-sction .row > div:nth-child(3) .portfolio-box {
  transition-delay: 0.3s;
}

.portfolio-sction .row > div:nth-child(4) .portfolio-box {
  transition-delay: 0.4s;
}

.portfolio-sction .row > div:nth-child(5) .portfolio-box {
  transition-delay: 0.5s;
}

.portfolio-sction .row > div:nth-child(6) .portfolio-box {
  transition-delay: 0.6s;
}

/* Add icon to portfolio boxes */
.portfolio-box .content::before {
  content: '✨';
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 40px;
  opacity: 0.3;
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  z-index: -1;
}

.portfolio-box:hover .content::before {
  transform: translateX(-50%) scale(1.2);
  opacity: 0.6;
}

.pagination-area {
  margin-top: 20px;
}

.pagination-area .pagination {
  padding-left: 0;
  margin-bottom: 0;
  list-style-type: none;
}

.pagination-area .page-link {
  border-color: #eeeeee;
  color: var(--blackColor);
  -webkit-box-shadow: unset !important;
          box-shadow: unset !important;
  -webkit-transition: var(--transition);
  transition: var(--transition);
  background-color: var(--whiteColor);
  font-weight: 700;
  font-size: var(--fontSize);
}

.pagination-area .page-link:hover, .pagination-area .page-link.active {
  color: var(--whiteColor);
  background-color: var(--mainColor);
}

/*================================================
Portfolio Details Section CSS
=================================================*/
.portfolio-details-desc .single-image {
  margin-bottom: 30px;
}

.portfolio-details-desc .single-box {
  margin-bottom: 20px;
  text-align: center;
  padding: 30px 20px;
  border: 1px solid #eeeeee;
  -webkit-transition: var(--transition);
  transition: var(--transition);
  background-color: var(--whiteColor);
}

.portfolio-details-desc .single-box .icon {
  display: inline-block;
  margin-bottom: 15px;
  width: 70px;
  height: 70px;
  background-color: #F7FAFD;
  color: var(--mainColor);
  -webkit-transition: var(--transition);
  transition: var(--transition);
  border-radius: 50%;
  position: relative;
  font-size: 35px;
}

.portfolio-details-desc .single-box .icon i {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
}

.portfolio-details-desc .single-box h4 {
  font-size: 20px;
  margin-bottom: 10px;
}

.portfolio-details-desc .single-box p {
  margin-bottom: 0;
  line-height: initial;
}

.portfolio-details-desc .single-box:hover {
  border-radius: 5px;
  border-color: var(--mainColor);
  -webkit-box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.08);
          box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.08);
}

.portfolio-details-desc .single-box:hover .icon {
  border-radius: 0;
  color: var(--whiteColor);
  background-color: var(--mainColor);
}

.portfolio-details-desc h3 {
  font-size: 22px;
  margin-bottom: 15px;
  margin-top: 20px;
}
/*================================================
Pricing Section CSS
=================================================*/
.pricing-plan {
  padding: 35px 25px;
  border-radius: 12px;
  margin-bottom: 30px;
  border: 1px solid #eeeeee;
  background: var(--whiteColor);
  -webkit-transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  opacity: 0;
  transform: translateY(30px);
  position: relative;
  overflow: hidden;
}

.pricing-plan::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--mainColor) 0%, #6a30d1 100%);
  transform: scaleX(0);
  transition: transform 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.pricing-plan:hover::before {
  transform: scaleX(1);
}

.pricing-plan .title {
  margin-bottom: 30px;
  position: relative;
  padding-left: 72px;
  text-align: center;
  padding-left: 0;
}

.pricing-plan .title .icon {
  left: 50%;
  top: 0;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  color: var(--whiteColor);
  background: linear-gradient(135deg, #6a30d1 0%, #5c83e3 100%);
  position: relative;
  text-align: center;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  font-size: 30px;
  margin-bottom: 20px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.pricing-plan:hover .title .icon {
  transform: translateX(-50%) scale(1.1) rotate(5deg);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.pricing-plan .title .icon i {
  left: 0;
  right: 0;
  top: 50%;
  position: absolute;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
}

.pricing-plan .title h3 {
  font-size: 24px;
  margin-bottom: 10px;
  color: var(--mainColor);
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.pricing-plan .title span {
  display: block;
  font-weight: 600;
  color: var(--optionalColor);
  font-size: 18px;
  margin-bottom: 5px;
}

.pricing-plan .features {
  margin-bottom: 30px;
  padding-left: 0;
  list-style-type: none;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  max-width: 250px;
}

.pricing-plan .features li {
  font-weight: 600;
  margin-bottom: 15px;
  color: var(--optionalColor);
  padding: 8px 0;
  transition: color 0.3s ease;
  text-align: left;
  display: flex;
  align-items: center;
  position: relative;
}

.pricing-plan:hover .features li {
  color: var(--blackColor);
}

.pricing-plan .features li i {
  flex-shrink: 0;
  color: var(--mainColor);
  font-size: 18px;
  width: 20px;
  text-align: center;
  margin-right: 15px;
  position: static;
  transform: none;
}

.pricing-plan .pricing-footer {
  text-align: center;
  border-top: 1px solid #eeeeee;
  margin-left: -25px;
  margin-right: -25px;
  padding-left: 25px;
  padding-right: 25px;
  padding-top: 25px;
}

.pricing-plan .pricing-footer .price {
  line-height: 1;
  font-size: 40px;
  font-weight: 800;
  color: var(--mainColor);
  transition: color 0.4s ease;
}

.pricing-plan:hover .pricing-footer .price {
  color: #6a30d1;
}

.pricing-plan .pricing-footer .price span {
  margin-left: 5px;
  display: inline-block;
  color: var(--optionalColor);
  font-size: 16px;
  font-weight: 600;
}

.pricing-plan .pricing-footer .default-btn {
  display: block;
  width: 100%;
  margin-top: 20px;
  padding: 12px 25px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.pricing-plan:hover {
  -webkit-transform: translateY(-15px);
          transform: translateY(-15px);
  border-color: var(--whiteColor);
  -webkit-box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
}

.pricing-plan:hover .default-btn {
  transform: scale(1.05);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

/* Animation trigger for pricing plans */
.pricing-plan.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* Enhanced staggered animation for pricing plans */
.pricing-section .row > div:nth-child(1) .pricing-plan {
  transition-delay: 0.1s;
}

.pricing-section .row > div:nth-child(2) .pricing-plan {
  transition-delay: 0.2s;
}

.pricing-section .row > div:nth-child(3) .pricing-plan {
  transition-delay: 0.3s;
}

.pricing-section .row > div:nth-child(4) .pricing-plan {
  transition-delay: 0.4s;
}

/*================================================
Partner Section CSS
=================================================*/
.partner-section {
  padding-top: 80px;
  padding-bottom: 80px;
}

.partner-title {
  margin-bottom: 50px;
  text-align: center;
}

.partner-title h3 {
  margin-bottom: 0;
  color: var(--blackColor);
  font-size: 24px;
  font-weight: 700;
}

.partner-item {
  margin-bottom: 30px;
  text-align: center;
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;
}

.partner-item.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* Staggered animation for partner items */
.partner-section .row > div:nth-child(1) .partner-item {
  transition-delay: 0.1s;
}

.partner-section .row > div:nth-child(2) .partner-item {
  transition-delay: 0.2s;
}

.partner-section .row > div:nth-child(3) .partner-item {
  transition-delay: 0.3s;
}

.partner-section .row > div:nth-child(4) .partner-item {
  transition-delay: 0.4s;
}

.partner-section .row > div:nth-child(5) .partner-item {
  transition-delay: 0.5s;
}

.partner-section .row > div:nth-child(6) .partner-item {
  transition-delay: 0.6s;
}

.partner-section .row > div:nth-child(7) .partner-item {
  transition-delay: 0.7s;
}

.partner-section .row > div:nth-child(8) .partner-item {
  transition-delay: 0.8s;
}

.partner-section .row > div:nth-child(9) .partner-item {
  transition-delay: 0.9s;
}

.partner-section .row > div:nth-child(10) .partner-item {
  transition-delay: 1.0s;
}

.partner-section .row > div:nth-child(11) .partner-item {
  transition-delay: 1.1s;
}

.partner-section .row > div:nth-child(12) .partner-item {
  transition-delay: 1.2s;
}

/* Country Card Styles */
.country-card {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--whiteColor);
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
}

.country-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  background: linear-gradient(135deg, var(--mainColor) 0%, #6a30d1 100%);
}

.country-flag {
  width: 48px;
  height: 36px;
  margin-right: 15px;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.1));
  border-radius: 4px;
  object-fit: cover;
}

.country-card:hover .country-flag {
  transform: scale(1.2) rotate(5deg);
}

.country-info {
  text-align: left;
}

.country-info h4 {
  margin: 0 0 8px 0;
  color: var(--blackColor);
  font-size: 18px;
  font-weight: 700;
  transition: color 0.4s ease;
}

.country-info .country-number {
  display: block;
  color: var(--optionalColor);
  font-size: 16px;
  font-weight: 600;
  transition: color 0.4s ease;
}

.country-card:hover .country-info h4,
.country-card:hover .country-info .country-number {
  color: var(--whiteColor);
}

/* Number animation */
.country-number {
  position: relative;
  overflow: hidden;
}

.country-number::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: var(--mainColor);
  transition: width 0.4s ease;
}

.country-card:hover .country-number::after {
  width: 100%;
  background: var(--whiteColor);
}

/* Responsive adjustments */
@media (max-width: 767px) {
  .country-card {
    flex-direction: column;
    text-align: center;
    padding: 15px;
  }
  
  .country-flag {
    margin-right: 0;
    margin-bottom: 10px;
    font-size: 35px;
  }
  
  .country-info {
    text-align: center;
  }
  
  .country-info h4 {
    font-size: 16px;
  }
  
  .country-info .country-number {
    font-size: 14px;
  }
}

/*================================================
Blog Section CSS
=================================================*/
.single-blog-item {
  text-align: center;
  margin-bottom: 30px;
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;
}

.single-blog-item .content {
  margin-top: 25px;
}

.single-blog-item .content h3 {
  font-size: 20px;
  line-height: 1.5;
  margin-bottom: 10px;
}

.single-blog-item .content .default-btn {
  margin-top: 5px;
}

/* Animation trigger for blog items */
.single-blog-item.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* Staggered animation for blog items */
.blog-section .row > div:nth-child(1) .single-blog-item {
  transition-delay: 0.1s;
}

.blog-section .row > div:nth-child(2) .single-blog-item {
  transition-delay: 0.2s;
}

.blog-section .row > div:nth-child(3) .single-blog-item {
  transition-delay: 0.3s;
}

/*================================================
Blog Details Section CSS
=================================================*/
.blog-details-content .meta {
  padding-left: 0;
  list-style-type: none;
  margin-bottom: 0;
  margin-top: 25px;
}

.blog-details-content .meta li {
  margin-right: 15px;
  display: inline-block;
  position: relative;
  color: var(--optionalColor);
  padding-left: 22px;
}

.blog-details-content .meta li i {
  position: absolute;
  left: 0;
  color: var(--mainColor);
  top: 3px;
}

.blog-details-content .meta li a {
  display: block;
  color: var(--optionalColor);
}

.blog-details-content .meta li a:hover {
  color: var(--mainColor);
}

.blog-details-content p {
  margin-bottom: 20px;
}

.blog-details-content p:last-child {
  margin-bottom: 0;
}

.blog-details-content h3 {
  font-size: 22px;
  margin-bottom: 20px;
  margin-top: 20px;
}

.blog-details-author {
  padding: 30px;
  margin-top: 30px;
  background-color: #F7FAFD;
}

.blog-details-author .media img {
  width: 120px;
  margin-right: 25px;
}

.blog-details-author .media .media-body h3 {
  font-size: 18px;
  margin-bottom: 12px;
}

.comments-area {
  margin-top: 30px;
  padding-top: 30px;
  border-top: 1px solid #eeeeee;
}

.comments-area .comment-title {
  font-size: 22px;
  margin-bottom: -5px;
}

.comments-area .comment-list .comment {
  position: relative;
  padding-left: 110px;
  padding-bottom: 30px;
  border-bottom: 1px solid #eeeeee;
  margin-top: 30px;
  margin-bottom: 30px;
}

.comments-area .comment-list .comment img {
  top: 0;
  left: 0;
  width: 90px;
  position: absolute;
}

.comments-area .comment-list .comment .comment-info {
  margin-bottom: 15px;
}

.comments-area .comment-list .comment .comment-info h4 {
  font-size: 18px;
  margin-bottom: 10px;
}

.comments-area .comment-list .comment .comment-info .post-date {
  position: relative;
  display: block;
  font-size: 14px;
  color: var(--optionalColor);
  padding-left: 18px;
}

.comments-area .comment-list .comment .comment-info .post-date i {
  position: absolute;
  left: 0;
  top: 3px;
  color: var(--mainColor);
}

.comments-area .comment-list .comment .reply-btn {
  display: inline-block;
  border: 1px solid #eeeeee;
  border-radius: 30px;
  padding: 4px 25px;
  font-size: 15px;
  font-weight: 700;
}

.comments-area .comment-list .comment .reply-btn:hover {
  color: var(--whiteColor);
  border-color: var(--mainColor);
  background-color: var(--mainColor);
}

.comments-area .comment-list .comment .comment {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.comments-area .comment-respond .comment-reply-title {
  font-size: 22px;
  margin-bottom: 20px;
}

.comments-area .comment-respond form .default-btn {
  margin-top: 10px;
}

/*================================================
Testimonials Area CSS
=================================================*/
.single-testimonials-item {
  padding: 35px 30px;
  text-align: center;
  border-radius: 5px;
  margin-bottom: 30px;
  background-color: var(--whiteColor);
  -webkit-box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.05);
          box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.05);
}

.single-testimonials-item img {
  border-radius: 70% 30% 30% 70% / 60% 40% 60% 40%;
  display: inline-block !important;
  width: 80px !important;
}

.single-testimonials-item .title {
  margin-left: 20px;
  text-align: left;
}

.single-testimonials-item .title h3 {
  font-size: 20px;
  margin-bottom: 8px;
}

.single-testimonials-item .title span {
  display: block;
  font-size: 14.5px;
  color: var(--optionalColor);
}

.single-testimonials-item p {
  margin-top: 25px;
}

/*================================================
Inner Page Banner Section CSS
=================================================*/
.inner-page-banner {
  z-index: 1;
  overflow: hidden;
  text-align: center;
  position: relative;
  padding-top: 170px;
  padding-bottom: 95px;
}

.inner-page-banner h2 {
  font-size: 35px;
  margin-bottom: 0;
}

/*================================================
404 Error Section CSS
=================================================*/
.error-content {
  text-align: center;
}

.error-content h2 {
  font-size: 30px;
  font-weight: 800;
  margin-top: 50px;
  margin-bottom: 30px;
}

/*================================================
Contact Section CSS
=================================================*/
.contact-form-wrapper h2 {
  font-size: 25px;
  margin-bottom: 25px;
}

.contact-form-wrapper form .form-group {
  margin-bottom: 20px;
}

.contact-form-wrapper form .default-btn {
  margin-top: 5px;
}

.contact-info-section {
  padding-top: 70px;
  padding-bottom: 40px;
}

.single-info-box {
  position: relative;
  padding-left: 90px;
  margin-bottom: 30px;
}

.single-info-box .icon {
  position: absolute;
  left: 0;
  top: 0;
  width: 70px;
  height: 70px;
  text-align: center;
  background-color: var(--mainColor);
  color: var(--whiteColor);
  font-size: 35px;
  -webkit-transition: var(--transition);
  transition: var(--transition);
  border-radius: 50%;
}

.single-info-box .icon i {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
}

.single-info-box p {
  margin-bottom: 2px;
  color: var(--blackColor);
  font-size: 20px;
  font-weight: 600;
}

.single-info-box:hover .icon {
  border-radius: 0;
}

.contact-form-image {
  padding-left: 50px;
}

/*================================================
FAQ Section CSS
=================================================*/
.faq-content {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.faq-content .faq-item {
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid #eeeeee;
}

.faq-content .faq-item h3 {
  font-size: 20px;
  margin-bottom: 0;
  position: relative;
  padding-left: 35px;
}

.faq-content .faq-item h3::before {
  width: 15px;
  height: 3px;
  background-color: var(--mainColor);
  position: absolute;
  left: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
  content: '';
}

.faq-content .faq-item .faq-ans {
  margin-top: 15px;
  margin-left: 35px;
}

.faq-content .faq-item:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

/*================================================
Footer Section CSS
=================================================*/
.footer-section {
  background-color: var(--blackColor);
  /* padding-bottom: 70px; */
}

.footer-widget {
  margin-bottom: 30px;
  padding: 10px 0;
}

.footer-widget .logo {
  margin-bottom: 15px;
  display: block;
}

.footer-widget .logo .logo-text {
  -webkit-text-fill-color: transparent;
  align-items: center;
  background: -webkit-gradient(linear, left top, left bottom, from(#428bf3), to(#3e30ff));
  -webkit-background-clip: text;
  background-clip: text;
  display: flex;
  flex-shrink: 0;
  font-size: 25px;
  font-weight: 700;
  height: 1.9rem;
  justify-content: space-between;
  /* margin-right: 35px; */
  text-align: center;
  cursor: pointer;
}

.footer-widget h3 {
  font-size: 20px;
  margin-bottom: 20px;
  color: var(--whiteColor);
}

.footer-widget p {
  opacity: 0.8;
  color: var(--whiteColor);
  margin-bottom: 15px;
  line-height: 1.6;
}

.footer-widget .links-list {
  padding-left: 0;
  margin-bottom: 0;
  list-style-type: none;
}

.footer-widget .links-list li {
  margin-bottom: 12px;
}

.footer-widget .links-list li:last-child {
  margin-bottom: 0;
}

.footer-widget .links-list li a {
  position: relative;
  display: inline-block;
  color: var(--whiteColor);
  opacity: 0.8;
  padding: 5px 0;
}

.footer-widget .links-list li a:hover {
  opacity: 1;
  color: var(--mainColor);
}

.footer-widget .footer-contact-info {
  padding-left: 0;
  margin-bottom: 0;
  list-style-type: none;
}

.footer-widget .footer-contact-info li {
  opacity: 0.8;
  position: relative;
  margin-bottom: 15px;
  color: var(--whiteColor);
  padding-left: 0;
  line-height: 1.6;
}

.footer-widget .footer-contact-info li:last-child {
  margin-bottom: 0;
}

.footer-widget .footer-contact-info li a {
  color: var(--whiteColor);
  text-decoration: none;
}

.footer-widget .footer-contact-info li a:hover {
  color: var(--mainColor);
}

.footer-widget .footer-contact-info li::before {
  display: none;
}

.footer-widget .social-links {
  padding-left: 0;
  list-style-type: none;
  margin-bottom: 0;
  margin-top: 25px;
}

.footer-widget .social-links li {
  display: inline-block;
  margin-right: 10px;
}

.footer-widget .social-links li a {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  border-radius: 50%;
  text-align: center;
  color: var(--blackColor);
  background-color: var(--whiteColor);
  transition: all 0.3s ease;
}

.footer-widget .social-links li a i {
  line-height: 1;
}

.footer-widget .social-links li a:hover {
  background-color: var(--mainColor);
  color: var(--whiteColor);
  transform: translateY(-3px);
}

.footer-widget .social-links li:last-child {
  margin-right: 0;
}

.copyright-area {
  margin-top: 70px;
  text-align: center;
  border-top: 1px solid #4f657a;
  padding-top: 25px;
  padding-bottom: 25px;
}

.copyright-area p {
  color: var(--whiteColor);
}

.copyright-area p strong {
  color: var(--whiteColor);
}

.copyright-area p a {
  font-weight: 700;
  color: var(--whiteColor);
}

/*================================================
Go Top CSS
=================================================*/
.go-top {
  position: fixed;
  cursor: pointer;
  bottom: 20px;
  right: 20px;
  z-index: 4;
  width: 43px;
  height: 45px;
  opacity: 0;
  font-size: 27px;
  visibility: hidden;
  text-align: center;
  color: var(--whiteColor);
  -webkit-transition: var(--transition);
  transition: var(--transition);
  background-color: var(--mainColor);
  -webkit-box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
          box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
}

.go-top i {
  right: 0;
  left: 0;
  top: 50%;
  text-align: center;
  position: absolute;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
  margin-left: auto;
  margin-right: auto;
}

.go-top.active {
  opacity: 1;
  visibility: visible;
  bottom: 20px;
}

.go-top:hover {
  color: var(--whiteColor);
  background-color: var(--blackColor);
}

/* Image Preview Modal Styles */
.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.image-preview-modal.show {
  opacity: 1;
  visibility: visible;
}

.image-preview-modal .modal-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-preview-modal .close-btn {
  position: absolute;
  top: -40px;
  right: -40px;
  background-color: rgba(0, 0, 0, 0.5);
  color: var(--whiteColor);
  border: none;
  font-size: 24px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.image-preview-modal .close-btn:hover {
  background-color: var(--mainColor);
}

.image-preview-modal .preview-img {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 5px;
}

/* Fix modal visibility */
.image-preview-modal {
  opacity: 1;
  visibility: visible;
}
</style>